import { render, staticRenderFns } from "./CreatTable.vue?vue&type=template&id=04c149a3&scoped=true"
import script from "./CreatTable.vue?vue&type=script&lang=js"
export * from "./CreatTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c149a3",
  null
  
)

export default component.exports